// eslint-disable-next-line import/no-cycle
import axios from './index';

/**
 * 学生用户中心验证码登录
 * @param {object} params
 * @param {string} params.code 验证码
 */
export function studentLoginByCode(params) {
  return axios({
    method: 'post',
    baseURL: `${process.env.VUE_APP_URL}/api/uc`,
    url: '/students/exchange/token',
    data: {
      clientId: window.clientId,
      deviceId: window.deviceId,
      ...params
    },
  });
}

/**
 * 学生登录
 * @param {object} params
 * @param {string} params.username 登录名
 * @param {string} params.password 登录密码
 */
export function studentLogin(params) {
  return axios({
    method: 'post',
    baseURL: `${process.env.VUE_APP_URL}/api/uc`,
    url:'/students/login',
    data:params
  });
}

/**
 * C++诊断——学生登录自动报名
 * @param {object} params
 * @param {string} params.competitionId 竞赛 id
 */
export function autoSignupAfterLogin(params) {
  return axios.post(`/inner/diagnostic/reg/${params.competitionId}`);
}

/**
 * C++诊断——获取诊断评估信息
 * @param {object} params
 * @param {string} params.moduleId 模块 id
 * @param {string} params.bundleId 题组 id
 */
export function getDiagnoseDetail(params) {
  return axios.get('/diagnostic/rest/assessInfo', { params });
}

/**
 * 教师登录
 * @param {object} params
 * @param {string} params.type 教师类型【0-主讲，1-辅导，2-班主任】（非必传）
 * @param {string} params.username 教师登录名
 * @param {string} params.password 教师登录密码
 * @param {string} params.schoolCode 登陆城市编码 010
 */
export function teacherLogin(params) {
  return axios({
    url: '/practice/platform/login/teacher',
    method: 'post',
    data: params,
  });
}

/**
 * 校区列表
 */
export function getCityList() {
  return axios({
    method:'get',
    baseURL: `${process.env.VUE_APP_URL}/api/uc`,
    url: '/students/findCityList',
  })
}
/**
 * 获取年级
 */
export function getGrid() {
  return axios({
    method:'get',
    baseURL: `${process.env.VUE_APP_URL}/api/uc`,
    url: '/students/reg/grids',
  })

}

/**
 * 新用户完善信息
 * @param {string} areaCode* 分校编码
 * @param {string} clientId* clientId
 * @param {string} code* 集团code
 * @param {string} deviceId* deviceId
 * @param {string} grid* 年级
 * @param {string} realname* 用户名
 * @param {integer($int32)} sex* 性别，0-女，1-男
 * @param {string} pCode 手机号
 */
export function studentsRegComplete(params) {
  return axios({
    method: 'post',
    baseURL: `${process.env.VUE_APP_URL}/api/uc`,
    url: '/students/reg/complete',
    data: {
      clientId: window.clientId,
      deviceId: window.deviceId,
      ...params
    },
  });
}

export function getDeleteAccountCode(params) {
  return axios.get('/practice/platform/login/account/cancel/captcha', {
    params,
  });
}

export function deleteAccount(params) {
  return axios.post('/practice/platform/login/account/cancel', params);
}
